<template>
  <a-modal
    class="modal-content"
    :title="`${modelType === 'edit' ? '编辑' : modelType === 'view' ? '查看' : '添加'}家访记录`"
    :width="900"
    :visible="visible"
    ok-text="保存"
    v-bind="extraProps"
    destroyOnClose
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        :model="form"
        :rules="rules"
      >
        <a-row :gutter="0" style="padding-left: 14px; padding-right: 26px">
          <a-col :span="8">
            <a-form-model-item
              label="选择年级"
              prop="gradeId"
              :labelCol="{ ...itemLabelCol }"
              :wrapperCol="itemWrapperCol"
            >
              <j-dict-select-tag
                placeholder="请选择年级"
                v-model="form.gradeId"
                :disabled="['edit', 'view', 'append'].includes(modelType)"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                allowClear
                @select="
                  () => {
                    $set(form, 'classId', undefined)
                    $set(form, 'studentId', undefined)
                  }
                "
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="选择班级"
              prop="classId"
              :labelCol="itemLabelCol"
              :wrapperCol="itemWrapperCol"
            >
              <j-dict-select-tag
                placeholder="请选择班级"
                v-model="form.classId"
                :dictCode="
                  'school_class,name,id,grade_id=' + (!form.gradeId ? -1 : form.gradeId)
                "
                :disabled="!form.gradeId || ['edit', 'view', 'append'].includes(modelType)"
                :isShowEmpty="false"
                @select="$set(form, 'studentId', undefined)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="选择学生"
              prop="studentId"
              :labelCol="itemLabelCol"
              :wrapperCol="itemWrapperCol"
            >
              <j-dict-select-tag
                placeholder="请选择学生"
                :isShowSearch="true"
                v-model="form.studentId"
                class="search-space"
                :disabled="!form.classId || ['edit', 'view', 'append'].includes(modelType)"
                :dictCode="'student_info,name,id,class_id=' + (!form.classId ? -1 : form.classId)"
                :async="true"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="家访时间" prop="visitTime">
          <a-date-picker
            showTime
            v-model="form.visitTime"
            placeholder="请选择日期"
            :disabled="isView"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="家访目的" prop="visitIntent">
          <j-dict-select-tag
            v-model="form.visitIntent"
            placeholder="请选择家访目的"
            :extraOptions="menuMaps.homeVisitPurpose"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item label="家庭情况" prop="familySituation">
          <a-popover
            v-model="familyPopoverVisible"
            trigger="click"
            placement="bottomLeft"
            overlayClassName="special-popover"
            :getPopupContainer="(trigger) => trigger.parentNode"
          >
            <template slot="content">
              <div class="special-dropdown-content" :style="{ width: triggerWidth + 'px' }">
                <div class="section">
                  <div class="section-title"><span class="required">*</span>家庭结构</div>
                  <div class="tag-group">
                    <a-checkable-tag
                      v-for="item in menuMaps.homeVisitStructure"
                      :key="item.value"
                      :checked="tempFamily.structure.includes(item.value)"
                      @change="(checked) => handleTagChange('structure', item.value, checked)"
                    >
                      {{ item.text }}
                    </a-checkable-tag>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title"><span class="required">*</span>家庭经济情况</div>
                  <div class="tag-group">
                    <a-checkable-tag
                      v-for="item in menuMaps.homeVisitFinancialSituation"
                      :key="item.value"
                      :checked="tempFamily.financialSituation === item.value"
                      @change="
                        (checked) => handleTagChange('financialSituation', item.value, checked)
                      "
                    >
                      {{ item.text }}
                    </a-checkable-tag>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title"><span class="required">*</span>家庭氛围</div>
                  <div class="tag-group">
                    <a-checkable-tag
                      v-for="item in menuMaps.homeVisitAtmosphere"
                      :key="item.value"
                      :checked="tempFamily.atmosphere === item.value"
                      @change="(checked) => handleTagChange('atmosphere', item.value, checked)"
                    >
                      {{ item.text }}
                    </a-checkable-tag>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title"><span class="required">*</span>亲子关系</div>
                  <div class="tag-group">
                    <a-checkable-tag
                      v-for="item in menuMaps.homeVisitChildRelationship"
                      :key="item.value"
                      :checked="tempFamily.childRelationship === item.value"
                      @change="
                        (checked) => handleTagChange('childRelationship', item.value, checked)
                      "
                    >
                      {{ item.text }}
                    </a-checkable-tag>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title"><span class="required">*</span>学生健康情况</div>
                  <a-textarea
                    v-model="tempFamily.healthCondition"
                    placeholder="请输入学生健康情况(如过敏、遗传病史、先天性疾病等)"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                    :max-length="200"
                  />
                </div>
                <div class="dropdown-footer">
                  <a-button @click="familyPopoverVisible = false">取消</a-button>
                  <a-button type="primary"  @click="confirmFamily">保存</a-button>
                </div>
              </div>
            </template>
            <div
              class="custom-select-trigger"
              :class="{ disabled: isView, active: familyPopoverVisible }"
            >
              <span v-if="familySituationText" class="trigger-text">{{ familySituationText }}</span>
              <span v-else class="trigger-placeholder">请选择家庭情况</span>
              <a-icon type="down" class="trigger-icon" />
            </div>
          </a-popover>
        </a-form-model-item>

        <a-form-model-item label="学业情况" prop="academicSituation">
          <a-popover
            v-model="academicPopoverVisible"
            trigger="click"
            placement="bottomLeft"
            overlayClassName="special-popover"
            :getPopupContainer="(trigger) => trigger.parentNode"
          >
            <template slot="content">
              <div class="special-dropdown-content" :style="{ width: triggerWidth + 'px' }">
                <div class="section">
                  <div class="section-title"><span class="required">*</span>成绩情况</div>
                  <div class="tag-group">
                    <a-checkable-tag
                      v-for="item in menuMaps.homeVisitPerformanceStatus"
                      :key="item.value"
                      :checked="tempAcademic.performanceStatus.includes(item.value)"
                      @change="
                        (checked) =>
                          handleAcademicTagChange('performanceStatus', item.value, checked)
                      "
                    >
                      {{ item.text }}
                    </a-checkable-tag>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title"><span class="required">*</span>上课情况</div>
                  <div class="tag-group">
                    <a-checkable-tag
                      v-for="item in menuMaps.homeVisitClassAttendance"
                      :key="item.value"
                      :checked="tempAcademic.classAttendance.includes(item.value)"
                      @change="
                        (checked) => handleAcademicTagChange('classAttendance', item.value, checked)
                      "
                    >
                      {{ item.text }}
                    </a-checkable-tag>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title"><span class="required">*</span>作业完成情况</div>
                  <div class="tag-group">
                    <a-checkable-tag
                      v-for="item in menuMaps.homeVisitHomeworkCompletionStatus"
                      :key="item.value"
                      :checked="tempAcademic.homeworkCompletionStatus === item.value"
                      @change="
                        (checked) =>
                          handleAcademicTagChange('homeworkCompletionStatus', item.value, checked)
                      "
                    >
                      {{ item.text }}
                    </a-checkable-tag>
                  </div>
                </div>
                <div class="dropdown-footer">
                  <a-button  @click="academicPopoverVisible = false">取消</a-button>
                  <a-button type="primary" @click="confirmAcademic">保存</a-button>
                </div>
              </div>
            </template>
            <div
              class="custom-select-trigger"
              :class="{ disabled: isView, active: academicPopoverVisible }"
            >
              <span v-if="academicSituationText" class="trigger-text">
                {{ academicSituationText }}
              </span>
              <span v-else class="trigger-placeholder">请选择学业情况</span>
              <a-icon type="down" class="trigger-icon" />
            </div>
          </a-popover>
        </a-form-model-item>
        <a-form-model-item label="家长配合度" prop="parentalCooperation">
          <j-dict-select-tag
            v-model="form.parentalCooperation"
            placeholder="请选择家长配合度"
            :disabled="isView"
            :extraOptions="menuMaps.parentalCooperation"
          />
        </a-form-model-item>
        <a-form-model-item label="应对措施" prop="responseMeasures">
          <j-dict-select-tag
            v-model="form.responseMeasures"
            placeholder="请选择应对措施"
            mode="multiple"
            :extraOptions="menuMaps.countermeasure"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item label="家访照片">
          <a-upload
            v-if="!isView"
            name="file"
            :multiple="true"
            :headers="tokenHeader"
            :action="importExcelUrl"
            :file-list="defaultFileList"
            @change="uploadFile"
            @preview="handlePreview"
          >
            <a-button v-if="defaultFileList.length < 3" icon="import">上传文件</a-button>
          </a-upload>
          <div v-else-if="isView && form.fileUrl" class="view-file-list">
            <span
              v-for="(url, index) in (form.fileUrl || '').split(',').filter(Boolean)"
              :key="index"
              class="view-file-item"
              @click="handleFilePreview(url)"
            >
              <a-icon type="paper-clip" />
              附件{{ index + 1 }}
            </span>
          </div>
          <span v-else>无</span>
        </a-form-model-item>
        <a-form-model-item label="综合评价" prop="comprehensiveEvaluation">
          <a-textarea
            v-model="form.comprehensiveEvaluation"
            placeholder="请输入具体情况说明"
            :auto-size="{ minRows: 4, maxRows: 8 }"
            :disabled="isView"
            :max-length="200"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction, getAction, getFileAccessHttpUrl } from '@api/manage'
import moment from 'moment'

export default {
  name: 'AddVisitRecordModal',
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '家访记录',
    },
  },
  computed: {
    isView() {
      return this.modelType === 'view'
    },
  },
  data() {
    return {
      visible: false,
      familyPopoverVisible: false,
      academicPopoverVisible: false,
      tempFamily: {
        structure: [],
        financialSituation: '',
        atmosphere: '',
        childRelationship: '',
        healthCondition: '',
      },
      tempAcademic: {
        performanceStatus: [],
        classAttendance: [],
        homeworkCompletionStatus: '',
      },
      familySituationText: '',
      academicSituationText: '',
      triggerWidth: 0,
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      itemLabelCol: { span: 8 },
      itemWrapperCol: { span: 15 },
      form: {},
      rules: {
        gradeId: [{ required: true, message: '请选择年级', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择班级', trigger: 'blur' }],
        studentId: [{ required: true, message: '请选择学生', trigger: 'blur' }],
        visitTime: [{ required: true, message: '请选择家访时间', trigger: 'change' }],
        visitIntent: [{ required: true, message: '请选择家访目的', trigger: 'change' }],
        familySituation: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                !value ||
                (!Array.isArray(value.structure) || value.structure.length === 0) ||
                !value.financialSituation ||
                !value.atmosphere ||
                !value.childRelationship ||
                !value.healthCondition
              ) {
                callback(new Error('请完善家庭情况信息'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        academicSituation: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                !value ||
                (!Array.isArray(value.performanceStatus) || value.performanceStatus.length === 0) ||
                (!Array.isArray(value.classAttendance) || value.classAttendance.length === 0) ||
                !value.homeworkCompletionStatus
              ) {
                callback(new Error('请完善学业情况信息'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        parentalCooperation: [{ required: true, message: '请选择家长配合度', trigger: 'change' }],
        responseMeasures: [{ required: true, message: '请选择应对措施', trigger: 'change' }],
        comprehensiveEvaluation: [{ required: true, message: '请输入综合评价', trigger: 'blur' }],
      },
      importExcelUrl: window._CONFIG['domianURL'] + '/sys/common/upload?biz=homeVisit',
      modelType: '',
      extraProps: {},
      defaultFileList: [],
      disableMixinCreated: true,
      menuMaps: {
        homeVisitPurpose: [],
        academicStatus: [],
        peerRelationship: [],
        learningEnvironment: [],
        parentChildRelationship: [],
        parentalCooperation: [],
        countermeasure: [],
        // 家庭氛围
        homeVisitAtmosphere: [],
        // 家庭结构
        homeVisitStructure: [],
        // 家庭经济情况
        homeVisitFinancialSituation: [],
        // 亲子关系
        homeVisitChildRelationship: [],
        // 成绩情况
        homeVisitPerformanceStatus: [],
        // 上课情况
        homeVisitClassAttendance: [],
        // 作业完成情况
        homeVisitHomeworkCompletionStatus: [],
      },
    }
  },
  created() {
    this.getMenuMaps()
  },
  methods: {
    async getMenuMaps() {
      const res = await getAction('/schoolHomeVisitRecord/queryHomeVisitParams', {})
      const result = res.result
      if (result) {
        for (let key in result) {
          if (result[key]) {
            const list = result[key].map((item) => {
              return {
                ...item,
                text: item.itemText,
                title: item.itemText,
                value: item.itemValue,
              }
            })
            this.$set(this.menuMaps, key, list)
          }
        }
      }
    },

    handleTagChange(field, value, checked) {
      const multiSelectFields = ['structure']
      if (multiSelectFields.includes(field)) {
        if (!Array.isArray(this.tempFamily[field])) this.tempFamily[field] = []
        if (checked) {
          this.tempFamily[field].push(value)
        } else {
          const index = this.tempFamily[field].indexOf(value)
          if (index > -1) this.tempFamily[field].splice(index, 1)
        }
      } else {
        if (checked) {
          this.tempFamily[field] = value
        } else {
          this.tempFamily[field] = ''
        }
      }
    },
    confirmFamily() {
      // 内部必填校验
      if (
        (!Array.isArray(this.tempFamily.structure) || this.tempFamily.structure.length === 0) ||
        !this.tempFamily.financialSituation ||
        !this.tempFamily.atmosphere ||
        !this.tempFamily.childRelationship ||
        !this.tempFamily.healthCondition
      ) {
        this.$message.warning('请完善所有必填的家庭情况项')
        return
      }

      // 组装文本
      const labels = []
      const mapping = [
        { field: 'structure', menu: 'homeVisitStructure' },
        { field: 'financialSituation', menu: 'homeVisitFinancialSituation' },
        { field: 'atmosphere', menu: 'homeVisitAtmosphere' },
        { field: 'childRelationship', menu: 'homeVisitChildRelationship' },
      ]
      mapping.forEach((m) => {
        const val = this.tempFamily[m.field]
        if (val) {
          if (Array.isArray(val)) {
            val.forEach(v => {
              const found = this.menuMaps[m.menu].find((i) => i.value === v)
              if (found) labels.push(found.text)
            })
          } else {
            const found = this.menuMaps[m.menu].find((i) => i.value === val)
            if (found) labels.push(found.text)
          }
        }
      })
      if (this.tempFamily.healthCondition) {
        labels.push(this.tempFamily.healthCondition)
      }
      this.familySituationText = labels.join('、')

      // 更新 form 并触发主表单校验
      this.$set(this.form, 'familySituation', { ...this.tempFamily })
      this.familyPopoverVisible = false
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('familySituation')
      })
    },
    handleAcademicTagChange(field, value, checked) {
      const multiSelectFields = ['performanceStatus', 'classAttendance']
      if (multiSelectFields.includes(field)) {
        if (!Array.isArray(this.tempAcademic[field])) this.tempAcademic[field] = []
        if (checked) {
          this.tempAcademic[field].push(value)
        } else {
          const index = this.tempAcademic[field].indexOf(value)
          if (index > -1) this.tempAcademic[field].splice(index, 1)
        }
      } else {
        if (checked) {
          this.tempAcademic[field] = value
        } else {
          this.tempAcademic[field] = ''
        }
      }
    },
    confirmAcademic() {
      // 内部必填校验
      if (
        (!Array.isArray(this.tempAcademic.performanceStatus) || this.tempAcademic.performanceStatus.length === 0) ||
        (!Array.isArray(this.tempAcademic.classAttendance) || this.tempAcademic.classAttendance.length === 0) ||
        !this.tempAcademic.homeworkCompletionStatus
      ) {
        this.$message.warning('请勾选所有必填的学业情况项')
        return
      }

      const labels = []
      const mapping = [
        { field: 'performanceStatus', menu: 'homeVisitPerformanceStatus' },
        { field: 'classAttendance', menu: 'homeVisitClassAttendance' },
        { field: 'homeworkCompletionStatus', menu: 'homeVisitHomeworkCompletionStatus' },
      ]
      mapping.forEach((m) => {
        const val = this.tempAcademic[m.field]
        if (val) {
          if (Array.isArray(val)) {
            val.forEach(v => {
              const found = this.menuMaps[m.menu].find((i) => i.value === v)
              if (found) labels.push(found.text)
            })
          } else {
            const found = this.menuMaps[m.menu].find((i) => i.value === val)
            if (found) labels.push(found.text)
          }
        }
      })
      this.academicSituationText = labels.join('、')

      this.$set(this.form, 'academicSituation', { ...this.tempAcademic })
      this.academicPopoverVisible = false
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('academicSituation')
      })
    },
    showModal(record, type) {
      this.visible = true
      this.$nextTick(() => {
        // 获取触发器容器的宽度，用于设置 Popover 面板宽度
        const trigger = this.$el.querySelector('.custom-select-trigger')
        if (trigger) {
          this.triggerWidth = trigger.offsetWidth - 32
        }
      })
      if (type === 'edit' || type === 'view') {
        this.form = {
          ...record,
          visitTime: record.visitTime ? moment(record.visitTime) : null,
        }
        // 解析嵌套对象
        if (record.learningEnvironment) {
          const env =
            typeof record.learningEnvironment === 'string'
              ? JSON.parse(record.learningEnvironment)
              : record.learningEnvironment
          // 处理多选字段：确保 structure 是数组
          if (env.structure && typeof env.structure === 'string') {
            env.structure = env.structure.split(',').filter(Boolean)
          } else if (!env.structure) {
            env.structure = []
          }
          this.tempFamily = { ...env }
          this.$nextTick(() => this.confirmFamily())
        }
        if (record.academicSituation) {
          const academic =
            typeof record.academicSituation === 'string'
              ? JSON.parse(record.academicSituation)
              : record.academicSituation
          // 处理多选字段：确保 performanceStatus 和 classAttendance 是数组
          if (academic.performanceStatus && typeof academic.performanceStatus === 'string') {
            academic.performanceStatus = academic.performanceStatus.split(',').filter(Boolean)
          } else if (!academic.performanceStatus) {
            academic.performanceStatus = []
          }
          if (academic.classAttendance && typeof academic.classAttendance === 'string') {
            academic.classAttendance = academic.classAttendance.split(',').filter(Boolean)
          } else if (!academic.classAttendance) {
            academic.classAttendance = []
          }
          this.tempAcademic = { ...academic }
          this.$nextTick(() => this.confirmAcademic())
        }

        this.extraProps = type === 'view' ? { footer: null } : {}
        this.modelType = type
        this.defaultFileList = record.fileUrl
          ? record.fileUrl
              .split(',')
              .filter(Boolean)
              .map((item, index) => ({
                uid: -index - 1,
                name: '照片' + (index + 1),
                status: 'done',
                url: item,
              }))
          : []
      } else {
        this.form = {
          gradeId: record?.gradeId,
          classId: record?.classId,
          studentId: record?.studentId,
        }
        this.modelType = type || 'add'
        this.defaultFileList = []
        // 新增模式下显式清空面板数据和文本
        this.tempFamily = {
          structure: [],
          financialSituation: '',
          atmosphere: '',
          childRelationship: '',
          healthCondition: '',
        }
        this.tempAcademic = {
          performanceStatus: [],
          classAttendance: [],
          homeworkCompletionStatus: '',
        }
        this.familySituationText = ''
        this.academicSituationText = ''
      }
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.modelType = ''
      // 清空自定义面板数据
      this.tempFamily = {
        structure: [],
        financialSituation: '',
        atmosphere: '',
        childRelationship: '',
        healthCondition: '',
      }
      this.tempAcademic = {
        performanceStatus: [],
        classAttendance: [],
        homeworkCompletionStatus: '',
      }
      this.familySituationText = ''
      this.academicSituationText = ''
      // 重置校验
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
      })
    },
    async handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const params = {
          visitTime: this.form.visitTime ? this.form.visitTime.format('YYYY-MM-DD HH:mm:ss') : '',
          studentId: this.form.studentId,
          visitIntent: this.form.visitIntent,
          // 学业情况：嵌套对象格式
          academicSituation: {
            performanceStatus: Array.isArray(this.form.academicSituation.performanceStatus)
              ? this.form.academicSituation.performanceStatus.join(',')
              : this.form.academicSituation.performanceStatus || '',
            classAttendance: Array.isArray(this.form.academicSituation.classAttendance)
              ? this.form.academicSituation.classAttendance.join(',')
              : this.form.academicSituation.classAttendance || '',
            homeworkCompletionStatus: Array.isArray(this.form.academicSituation.homeworkCompletionStatus)
              ? this.form.academicSituation.homeworkCompletionStatus.join(',')
              : this.form.academicSituation.homeworkCompletionStatus || '',
          },
          // 家庭情况：嵌套对象格式
          learningEnvironment: {
            structure: Array.isArray(this.form.familySituation.structure)
              ? this.form.familySituation.structure.join(',')
              : this.form.familySituation.structure || '',
            financialSituation: Array.isArray(this.form.familySituation.financialSituation)
              ? this.form.familySituation.financialSituation.join(',')
              : this.form.familySituation.financialSituation || '',
            atmosphere: Array.isArray(this.form.familySituation.atmosphere)
              ? this.form.familySituation.atmosphere.join(',')
              : this.form.familySituation.atmosphere || '',
            childRelationship: Array.isArray(this.form.familySituation.childRelationship)
              ? this.form.familySituation.childRelationship.join(',')
              : this.form.familySituation.childRelationship || '',
            healthCondition: this.form.familySituation.healthCondition || '',
          },
          parentalCooperation: this.form.parentalCooperation,
          responseMeasures: Array.isArray(this.form.responseMeasures)
            ? this.form.responseMeasures.join(',')
            : this.form.responseMeasures,
          comprehensiveEvaluation: this.form.comprehensiveEvaluation,
          fileUrl: this.defaultFileList
            .filter((item) => item.status === 'done')
            .map((item) => item.url || item.response?.message || item.response?.result)
            .filter(Boolean)
            .join(','),
        }
        if (this.form.id) params.id = this.form.id
        const url =
          this.modelType === 'edit' ? '/schoolHomeVisitRecord/edit' : '/schoolHomeVisitRecord/add'
        const res = await postAction(url, params)
        if (res.success) {
          this.$message.success(res.message)
          this.hideModal()
          this.$emit('refreshData')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleCancel() {
      this.hideModal()
    },
    uploadFile(info) {
      let fileList = [...info.fileList]
      if (fileList.length > 3) {
        this.$message.warning('最多只能上传 3 张照片')
        fileList = fileList.slice(0, 3)
      }
      this.defaultFileList = fileList
      if (info.file.status === 'done' && info.file.response.success) {
        this.$message.success('上传成功')
      }
    },
    handlePreview(file) {
      const url = file.url || file.response?.message || file.response?.result
      if (url) window.open(getFileAccessHttpUrl(url))
    },
    handleFilePreview(url) {
      if (url) window.open(getFileAccessHttpUrl(url))
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-form-item {
    margin-bottom: 12px;
  }
}
.view-file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.view-file-item {
  color: #1890ff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.custom-select-trigger {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    border-color: #40a9ff;
  }

  &.active {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &.disabled {
    color: rgba(0, 0, 0, 0.25);
    background: #f5f5f5;
    cursor: not-allowed;
    &:hover {
      border-color: #d9d9d9;
    }
  }

  .trigger-text {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .trigger-placeholder {
    flex: 1;
    color: #bfbfbf;
  }

  .trigger-icon {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;
    transition: transform 0.3s;
  }

  &.active .trigger-icon {
    transform: rotate(180deg);
  }
}

.special-popover {
  /deep/ .ant-popover-inner-content {
    padding: 0;
  }
}

.special-dropdown-content {
  .section {
    margin-bottom: 8px;
    .section-title {
      font-weight: bold;
      margin-bottom: 8px;
      font-size: 12px;
      color: rgba(0, 0, 0, 1);
      .required {
        color: #f5222d;
        margin-right: 4px;
        font-family: SimSun, sans-serif;
      }
    }
    .tag-group {
      display: flex;
      flex-wrap: wrap;
      gap: 8px 0;
      .ant-tag-checkable {
        height: 28px;
        line-height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(230, 230, 230, 1);
        &.ant-tag-checkable-checked {
          background-color: #1890ff;
          border-color: #1890ff;
        }
      }
    }
  }
  .dropdown-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
  }
}
</style>
